import { BodyProcessField } from './body-process-field';
import { Process } from '../data/process';

export class BodyProcess {
  formId: string | undefined;
  status: string | undefined;
  fields: BodyProcessField[];

  constructor(process: Process) {
    this.formId = process.formId;
    this.status = process.status;
    this.fields = [];
    if (process.fields) {
      for (const field of process.fields) {
        this.fields.push(new BodyProcessField(field));
      }
    }
  }
}
